(function () {
  const OVER_HERO_CLASS = 'nuday-header-over-hero';
  const PAST_HERO_CLASS = 'nuday-header-past-hero';
  const PAGE_OVERLAY_CLASS = 'nuday-header-page-overlay';
  const HIDE_ANNOUNCEMENT_CLASS = 'nuday-hide-announcement';

  const EXIT_THRESHOLD = 64;
  const ENTER_THRESHOLD = 120;

  let activeHero = null;
  let hideAnnouncement = false;
  let isOverHero = null;
  let ticking = false;
  let isTransitioning = false;

  function syncHeaderHeight() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const height = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
    document.documentElement.style.setProperty('--nuday-header-height', `${height}px`);
  }

  function clearStickyHeaderClasses() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate',
      'scrolled-past-header'
    );
  }

  function applyClasses(overHero) {
    document.documentElement.classList.toggle(OVER_HERO_CLASS, overHero);
    document.documentElement.classList.toggle(PAST_HERO_CLASS, !overHero);
    document.documentElement.classList.toggle(
      HIDE_ANNOUNCEMENT_CLASS,
      overHero && hideAnnouncement
    );
  }

  function setHeaderState(overHero) {
    if (isOverHero === overHero || isTransitioning) return;

    const isOverlayPage = document.documentElement.classList.contains(PAGE_OVERLAY_CLASS);
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    const scrollBefore = window.scrollY;
    const heightBefore = !isOverlayPage && headerGroup ? headerGroup.offsetHeight : 0;

    isTransitioning = true;
    isOverHero = overHero;

    applyClasses(overHero);
    clearStickyHeaderClasses();

    if (!overHero && !isOverlayPage) {
      const header = document.querySelector('.section-header');
      if (header) {
        header.classList.add('shopify-section-header-sticky');
      }
    }

    if (!isOverlayPage && headerGroup) {
      const heightAfter = headerGroup.offsetHeight;
      const delta = heightAfter - heightBefore;

      if (delta !== 0) {
        window.scrollTo(0, scrollBefore + delta);
      }
    }

    syncHeaderHeight();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        isTransitioning = false;
      });
    });
  }

  function computeOverHero(rect) {
    if (rect.top >= window.innerHeight) {
      return false;
    }

    if (isOverHero === null) {
      return rect.bottom > EXIT_THRESHOLD;
    }

    if (isOverHero) {
      return rect.bottom > EXIT_THRESHOLD;
    }

    return rect.bottom > ENTER_THRESHOLD;
  }

  function updateFromHeroRect() {
    ticking = false;

    if (!activeHero || activeHero.dataset.headerOverlay !== 'true') return;

    const rect = activeHero.getBoundingClientRect();
    setHeaderState(computeOverHero(rect));
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateFromHeroRect);
    }
  }

  function observeHero(hero) {
    activeHero = hero;

    if (!hero || hero.dataset.headerOverlay !== 'true') {
      isOverHero = null;
      document.documentElement.classList.remove(
        PAGE_OVERLAY_CLASS,
        OVER_HERO_CLASS,
        PAST_HERO_CLASS,
        HIDE_ANNOUNCEMENT_CLASS
      );
      return;
    }

    document.documentElement.classList.add(PAGE_OVERLAY_CLASS);
    hideAnnouncement = hero.dataset.hideAnnouncement === 'true';
    isOverHero = null;
    isTransitioning = false;

    clearStickyHeaderClasses();
    updateFromHeroRect();
    syncHeaderHeight();
  }

  function getActiveHero() {
    const heroes = document.querySelectorAll('[data-nuday-hero]');
    return heroes.length ? heroes[0] : null;
  }

  function init() {
    observeHero(getActiveHero());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    syncHeaderHeight();
    onScroll();
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-nuday-hero]')) {
      observeHero(getActiveHero());
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('[data-nuday-hero]')) {
      observeHero(getActiveHero());
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    const hero = event.target.querySelector('[data-nuday-hero]');
    if (hero) {
      observeHero(hero);
    }
  });

  document.addEventListener('shopify:section:deselect', function () {
    observeHero(getActiveHero());
  });

  document.addEventListener('shopify:block:select', function (event) {
    const hero = event.target.closest('[data-nuday-hero]');
    if (hero) {
      observeHero(hero);
    }
  });
})();
